import styles from "./index.css";

const PlaceholderImage = () => <img className={styles.image} alt="" />;

export default PlaceholderImage;
